export enum TABS {
    CALENDAR = "calendar",
    CLIENTS = "clients",
    CLIENTS_FEEDBACK = "clientsFeedback",
    PAYMENTS = "payments",
}
